/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { Container, FlexContainer, H2, Modal, Text } from "@carrotfertility/carotene"
import React from "react"
import { useSelector } from "react-redux"
import { getCarrotLite } from "reducers/companyInfo"
import { FormattedMessage } from "react-intl"

export function PartnerAccessInfoModal({ onExit }): JSX.Element {
  const isCarrotLite = useSelector(getCarrotLite)
  return (
    <Modal onClose={onExit} open={true} showClose={true}>
      <FlexContainer padding={"huge"} direction={"column"}>
        <Container stack={"huge"}>
          <H2 color={"black80"} stack={"tiny"}>
            <FormattedMessage defaultMessage="What does it mean to view their account?" />
          </H2>
          <Text color={"black60"}>
            <Container sx={{ marginTop: 20, marginBottom: 20 }}>
              <FormattedMessage
                defaultMessage="When you sign in to the Carrot member’s account with your own email and password, you can access their
              educational resources, benefit details, and more."
              />
            </Container>
            {!isCarrotLite && (
              <FormattedMessage defaultMessage="For access to a member-only space, such as Financial support or Messages, please ask the member to sign in to their account. If you send a message to our Care Team, they will reply to you via email." />
            )}
            {isCarrotLite && (
              <FormattedMessage defaultMessage="For access to a member-only space, such as Messages, please ask the member to sign in to their account. If you send a message to our Care Team, they will reply to you via email." />
            )}
          </Text>
        </Container>
      </FlexContainer>
    </Modal>
  )
}
